<template>
  <div class="centerPage">
    <div class="pageTit">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/systemArticle/list' }">
          系统文章管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ status === 0 ? '新增' : '编辑' }}文章
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" :model="articleData" class="article_edit" :rules="rules">
      <el-form-item label="类型: " v-show="status===0" prop="">
        <el-radio-group v-model="itemId" @change="changeItem()">
          <el-radio :label="item.id" v-for="item in itemList" :key="item.id">{{ item.itemName }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="文章类型: " v-show="status===0" prop="dictCatalogSubitemId">
        <el-radio-group v-model="articleData.dictCatalogSubitemId">
          <el-radio :label="subitem.id" v-for="subitem in subitemList" :key="subitem.id">{{
              subitem.subName
            }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="缩略图：">
        <el-upload
            v-if="articleData.thumbnailPath"
            :limit="1"
            :action="uploadUrl"
            name="uploadFile"
            list-type="picture-card"
            class="uploadImg"
            :on-success="handleImageSuccess">
          <div v-if="imageUrl">只能上传一张图
          </div>
          <div v-else class="maxHeight">
            <div v-if="imageUrl"></div>
            <div v-else :style="'backgroundImage: url('+articleData.thumbnailPath+')'" class="img"></div>
          </div>
        </el-upload>
        <el-upload
            v-else
            :limit="1"
            :action="uploadUrl"
            name="uploadFile"
            list-type="picture-card"
            class="uploadImg"
            :on-success="handleImageSuccess">
          <span slot="default">点击上传</span>
        </el-upload>
      </el-form-item>
      <el-form-item label="标题：" prop="title">
        <el-input v-model="articleData.title" style="width: 1000px" placeholder="请输入标题">{{ articleData.title }}?
        </el-input>
      </el-form-item>
      <el-form-item label="简述：" prop="summary">
        <el-input v-model="articleData.summary" type="textarea"
                  :autosize="{ minRows: 3, maxRows: 3}" style="width: 1000px" placeholder="请输入简述"></el-input>
      </el-form-item>
      <el-form-item label="正文：" class="quill_parent" prop="pageContent">
        <tinymce v-model="articleData.pageContent" :height="300" style="width: 1000px"/>
      </el-form-item>
      <div class="btn">
        <el-button @click="back()">
          返回
        </el-button>
        <el-button @click="save()">
          保存
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import base from '@/api/common';
import Tinymce from '@/components/Tinymce'


export default {
  name: "articleSystemEdit",
  data() {
    return {
      status: Number(this.$route.query.status),
      articleId: this.$route.query.id,
      articleData: {
        dictCatalogSubitemId: null,
        thumbnailPath: null,
        title: null,
        summary: null,
        pageContent: null,
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {min: 1, max: 200, message: '标题过长', trigger: 'blur'}
        ],
        summary: [
          {required: true, message: '请输入摘要', trigger: 'blur'},
          {min: 1, max: 1000, message: '简述过长', trigger: 'blur'}
        ],
        // pageContent: [
        //   {required: true, message: '请输入正文', trigger: 'blur'},
        // ],
      },
      itemId: null,
      itemList: [],
      subitemList: [],
      uploadUrl: base.uploadUrl + "articleSystem" || '',
      imageUrl: '',// 新增上传组件显示上传的图片

    }
  },
  mounted() {
    if (this.status === 0) {
      //新增
      this.getItemList();
    } else {
      //更新
      this.getArticleData();
    }
  },
  methods: {
    //获得类型数据
    getItemList() {
      let that = this;
      this.$ajax.get(base.api.dict.edit.item.listByCode.replace("{code}", "article_system")).then((res) => {
        if (res.data.status === 'success') {
          that.itemList = res.data.list;
          if (that.status === 0) {
            //如果是新增
            that.itemId = res.data.list[0].id;
            that.changeItem();
          }
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("获取字典失败");
      })
    },
    //改变item
    changeItem() {
      for (let item of this.itemList) {
        if (item.id === this.itemId) {
          this.subitemList = item.subitemList;
          this.articleData.dictCatalogSubitemId = item.subitemList[0].id;
          return;
        }
      }
    },
    //上传图片
    handleImageSuccess(res, file) {// 新增上传组件
      this.imageUrl = URL.createObjectURL(file.raw);
      this.articleData.thumbnailPath = res.message;
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let that = this;
          let url = base.manager_api.article.system.update;
          if (this.status === 0) {
            //新增
            url = base.manager_api.article.system.add;
          } else if (!this.articleData.id) {
            this.$message.error("操作失败");
            return;
          }

          this.$ajax.post(url, this.articleData).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
              that.back();
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err)
            that.$message.error('操作失败');
          })
        } else {
          this.$message.error('请检查字段');
        }
      })
    },
    back() {
      this.$router.push({path: 'list'})
    },
    getArticleData() {
      let that = this;
      this.$ajax.get(base.manager_api.article.system.getById.replace("{id}", this.articleId)).then((res) => {
        if (res.data.status === 'success') {
          that.articleData = res.data.data;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败")
      })
    }
  },
  components: {
    Tinymce
  }
}
</script>

<style scoped lang="scss">
//@import '../../../assets/css/admin.scss';
@import '../../../assets/css/banner.scss';

.centerPage {
  display: block;
}

.ql-snow .ql-color-picker, .ql-snow .ql-picker.ql-header {
  line-height: 24px;
}
</style>
